<template>
    <div class="background">
        <p style="font-weight:bold;font-size:2.5rem;">淘菜菜开码</p>
        <div style="padding:0.5rem 0;">
            <div class="inputForm">
                <van-field v-model="query.name" label="真实姓名" placeholder="请填写真实姓名" clearable/>
                <van-field v-model="query.taobaoid" label="淘宝ID" placeholder="请填写淘宝ID" clearable/>
                <van-field v-model="query.idno" label="身份证号码" placeholder="请填写身份证号码" clearable/>
                <van-field v-model="query.mobile" label="手机号码" placeholder="请填写手机号码" clearable/>
                <van-field v-model="query.province" label="省级地址" placeholder="请选择省/市" clearable  @click="showProvince=true"/>
                <van-field v-model="query.city" label="市级地址" placeholder="请选择市/区" clearable  @click="openCityPopup"/>
                <van-button type="danger" size="large" round @click="submit" style="margin-top:2rem;height:3rem;">提交</van-button>
            </div>
            <div style="font-size:1rem;margin-top:1rem;">淘宝id到：淘宝app-我的-设置中获取</div>
            <div style="font-size:1rem;">淘菜菜提交成功后，淘特可以使用相同淘宝账号登录零销宝同步作业</div>
        </div>

        <van-popup v-model="showProvince" position="bottom">
            <van-picker show-toolbar title="省/市选择" :columns="provinceList" @confirm="onProvinceConfirm" @cancel="showProvince=false"/>
        </van-popup>

        <van-popup v-model="showCity" position="bottom">
            <van-picker show-toolbar title="市/区选择" :columns="cityList" @confirm="onCityConfirm" @cancel="showCity=false"/>
        </van-popup>
    </div>
</template>

<script>
    import taobaotejiaAPI from '@/api/taobaotejia';

    export default {
        data() {
            return {
                query: {
                    traderId: this.$route.query.traderId,
                },
                provinceMap: [],
                provinceList: [],
                cityList: [],
                showProvince: false,
                showCity: false,
            }
        },
        methods: {
            openCityPopup() {
                if (!this.provinceMap[this.query.province]) {
                    this.$toast("请先填写省级地址");
                    return;
                }
                this.cityList = [];
                taobaotejiaAPI.getCity(this.provinceMap[this.query.province]).then((result) => {
                    if (result.data) {
                        result.data.map(e => {
                            this.cityList.push(e.name);
                        });
                        this.showCity = true;
                    }
                })
            },
            onProvinceConfirm(value, index) {
                this.query.province = value;
                this.query.city = null;
                this.showProvince = false;
            },
            onCityConfirm(value, index) {
                this.query.city = value;
                this.showCity = false;
            },
            submit() {
                if (!this.query.name || !this.query.taobaoid || !this.query.idno || !this.query.mobile || !this.query.province || !this.query.city) {
                    this.$toast("请先填写相关信息");
                    return;
                }
                if (!this.$myUtil.mobile(this.query.mobile)) {
                    this.$toast("手机号不正确");
                    return;
                }
                taobaotejiaAPI.tccApply(this.query).then(() => {
                    this.query = {};
                    this.query.traderId = this.$route.query.traderId;
                    this.$toast("提交成功");
                })
            },
        },
        created() {
            taobaotejiaAPI.getProvince().then((result) => {
                if (result.data) {
                    result.data.map(e => {
                        this.provinceList.push(e.name);
                        this.provinceMap[e.name] = e.id;
                    })
                }
            })
        },
    }

</script>

<style lang="scss" scoped>
    .background {
        padding-top: 2rem;
        text-align: center;
        /*padding: 0;*/
    }

    .inputForm {
        background-color: white;
        width: 80%;
        margin: 0 auto;
        border-radius: 1rem;
        padding: 0.5rem 1rem;
        text-align: center;
    }

</style>
